import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "tournament-ranking-section",
  "data-qe-id": "ranking-section"
}
const _hoisted_2 = { class: "t-table-tabs" }

import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import MSeasonTable from '@/modules/MSeasonTable.vue'
import MTournamentTable from '@/modules/MTournamentTable.vue'
import MZoneHistoryTable from '@/modules/MZoneHistoryTable.vue'
import { TOURNAMENT_TYPE, TournamentTypeToName } from '@/model/TournamentType'

enum TableType {
  SEASON = 'ranking.tabletype.season',
  TOURNAMENT = 'ranking.tabletype.tournament',
  ZONE_HISTORY = 'ranking.tabletype.zoneHistory',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MRankingSection',
  setup(__props) {

const route = useRoute()
const store = useStore()
const { t } = useI18n()

const TABLE_SEASON = TableType.SEASON
const TABLE_TOURNAMENT = TableType.TOURNAMENT
const TABLE_ZONE_HISTORY = TableType.ZONE_HISTORY

const tableToShow = ref(TABLE_ZONE_HISTORY)

const tabLabelHistory = computed(() => {
  return isMasters.value ? t('table.type.zone_history') : t('table.type.onetime_history')
})

const tabLabelTournament = computed(() => {
  return isMasters.value ? t('table.type.tournament_weekly') : t('table.type.onetime')
})

const isMasters = computed(() => {
  return (
    store.state.zone.zoneId === TournamentTypeToName[TOURNAMENT_TYPE.SKA_MASTERS] ||
    store.state.zone.zoneId === TournamentTypeToName[TOURNAMENT_TYPE.SKA_MASTERS_GD] ||
    store.state.zone.zoneId === TournamentTypeToName[TOURNAMENT_TYPE.ROM_MASTERS] ||
    store.state.zone.zoneId === TournamentTypeToName[TOURNAMENT_TYPE.ROM_MASTERS_GD]
  )
})

const mastersTabLabel = computed(() => {
  const label = t('table.type.masters_season') as string
  const game = t(`generic.game.name_${store.state.zone.gametype}`) as string
  return label.replace('{gametype}', game)
})

const hasTournamentId = computed(() => {
  return !!store.state.tournament.tournamentId
})

const tid = computed(() => {
  return store.state.tournament.tournamentId
})

onMounted(() => {
  // find out which table has to be preselected
  if (route.query.table === 'history') {
    // the query has first prio - the others I don't know
    tableToShow.value = TABLE_ZONE_HISTORY
    document.getElementById('tournament-ranking-section').scrollIntoView({ behavior: 'smooth' })
  } else if (hasTournamentId.value) {
    tableToShow.value = TABLE_TOURNAMENT
  } else if (isMasters.value) {
    tableToShow.value = TABLE_SEASON
  }
})

function hasSelectionState(state: TableType) {
  return tableToShow.value === state ? 't-table-tabs-active' : ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (hasTournamentId.value)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: _normalizeClass(hasSelectionState(_unref(TABLE_TOURNAMENT))),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (tableToShow.value = _unref(TABLE_TOURNAMENT))),
            "data-qe-id": "table-selection-tab--current"
          }, _toDisplayString(tabLabelTournament.value), 3))
        : _createCommentVNode("", true),
      (isMasters.value)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: _normalizeClass(hasSelectionState(_unref(TABLE_SEASON))),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (tableToShow.value = _unref(TABLE_SEASON))),
            "data-qe-id": "table-selection-tab--masters"
          }, _toDisplayString(mastersTabLabel.value), 3))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        class: _normalizeClass(hasSelectionState(_unref(TABLE_ZONE_HISTORY))),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (tableToShow.value = _unref(TABLE_ZONE_HISTORY))),
        "data-qe-id": "table-selection-tab--history"
      }, _toDisplayString(tabLabelHistory.value), 3)
    ]),
    (isMasters.value && tableToShow.value === _unref(TABLE_SEASON))
      ? (_openBlock(), _createBlock(MSeasonTable, {
          key: 0,
          "zone-id": _unref(store).state.zone.zoneId,
          "data-qe-id": "ranking-table--masters"
        }, null, 8, ["zone-id"]))
      : _createCommentVNode("", true),
    (tableToShow.value === _unref(TABLE_TOURNAMENT))
      ? (_openBlock(), _createBlock(MTournamentTable, {
          key: 1,
          "t-id": tid.value,
          "data-qe-id": "ranking-table--current"
        }, null, 8, ["t-id"]))
      : _createCommentVNode("", true),
    (tableToShow.value === _unref(TABLE_ZONE_HISTORY))
      ? (_openBlock(), _createBlock(MZoneHistoryTable, {
          key: 2,
          "zone-id": _unref(store).state.zone.zoneId,
          "data-qe-id": "ranking-table--history"
        }, null, 8, ["zone-id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})